import { getCookieValue } from "~/utils/cookies";

/**
 * SFCC-12333 session flag. No `max-age` / `expires`, so it is a session
 * cookie: the browser drops it when it closes, which is the ticket's
 * definition of a session (refresh and continued browsing keep it). A cookie
 * rather than `sessionStorage`, which is per tab — a second tab would show the
 * reminder again.
 */
export const CART_REMINDER_COOKIE = "hec_cart_reminder_seen";

export const readCartReminderSeen = (): boolean =>
  typeof document !== "undefined" &&
  getCookieValue(document.cookie, CART_REMINDER_COOKIE) === "1";

export const markCartReminderSeen = (): void => {
  if (typeof document === "undefined") return;
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${CART_REMINDER_COOKIE}=1; path=/; SameSite=Lax${secure}`;
};
